import { render } from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=template&id=15540fa0&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPackagedDigitalPublications.vue?vue&type=style&index=0&id=15540fa0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15540fa0"]])

export default __exports__